// extracted by mini-css-extract-plugin
export default {"title":"ResearchCard_title__xuvup","description":"ResearchCard_description__rwX+S"};